import axios from '@/axios.config.js';

class CourseService {
    createCourse(cancelToken, course) {
        const data = {
            name: course.name,
            description: course.description,
        }
        if (course.image_name) {
            data.image_name = course.image_name
        }
        if (course.attachment_name) {
            data.attachment_name = course.attachment_name
        }
        return axios
            .post('courses', data, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateCourse(cancelToken, course) {
        const data = {
            name: course.name,
            description: course.description,
        }
        if (course.image_name) {
            data.image_name = course.image_name
        }
        if (course.attachment_name) {
            data.attachment_name = course.attachment_name
        }
        return axios
            .patch(`courses/${course.id}`, data, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteCourse(cancelToken, courseId) {
        return axios
            .delete(`courses/${courseId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getCourse(cancelToken, courseId) {
        return axios
            .get(`courses/${courseId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listCourses(cancelToken) {
        return axios
            .get('courses', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }
}

export default new CourseService();